var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Network',{ref:"test",attrs:{"id":"network","nodes":_vm.network_nodes,"edges":_vm.network_edges,"options":_vm.network_options}})
}
var staticRenderFns = []

export { render, staticRenderFns }